import { render } from "./PageProfitStatsProjectDetail.vue?vue&type=template&id=49394c18"
import script from "./PageProfitStatsProjectDetail.vue?vue&type=script&lang=js"
export * from "./PageProfitStatsProjectDetail.vue?vue&type=script&lang=js"

import exportComponent from "/home/ad5hitotsuki/hitotsuki.net/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__